var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3979 1.00387C14.2869 1.01586 14.1833 1.06496 14.1037 1.1432L1.67246 13.5822C1.59871 13.6556 1.54995 13.7504 1.5331 13.8531L1.00675 17.1815C0.994904 17.2585 1.00135 17.3371 1.02556 17.4111C1.04976 17.485 1.09106 17.5522 1.14609 17.6073C1.20112 17.6623 1.26834 17.7036 1.34231 17.7278C1.41627 17.752 1.4949 17.7584 1.57182 17.7466L4.90024 17.2202C5.00202 17.2055 5.0967 17.1596 5.17117 17.0886L17.6102 4.64966C17.6567 4.60358 17.6937 4.54872 17.7189 4.48827C17.7442 4.42782 17.7571 4.36297 17.7571 4.29746C17.7571 4.23196 17.7442 4.16709 17.7189 4.10664C17.6937 4.04619 17.6567 3.99134 17.6102 3.94527L14.8081 1.1432C14.7547 1.09042 14.6901 1.05045 14.619 1.02631C14.548 1.00217 14.4723 0.994509 14.3979 1.00387ZM14.452 2.19591L16.5575 4.30133L15.6828 5.17601L13.5773 3.07059L14.452 2.19591ZM12.873 3.77498L14.9784 5.8804L5.17117 15.6876L3.06575 13.5822L12.873 3.77498ZM2.45424 14.364L4.38936 16.2991L2.09042 16.6629L2.45424 14.364Z",
    fill: "#43927C",
    stroke: "#43927C",
    strokeWidth: 0.273913
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.68478,
    y1: 21.3152,
    x2: 16.75,
    y2: 21.3152,
    stroke: "#43927C",
    strokeWidth: 1.36957,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.cd6f0b7c4604bd126a05f48cdb0a3976.svg";
export { ForwardRef as ReactComponent };